import type { ComponentsMap } from '@frontend/formEngine/readForm/readForm.types';
import { ReadForm } from '@frontend/formEngine/readForm/ReadForm';
import { excludeFormComponent } from '@frontend/formEngine/readForm/readFormComponents';
import { useDefinedContext } from '@frontend/utils/hooks/useDefinedContext';
import { ProcessActivityReadContext } from '../../../carePath/process/processActivity/processActivityRead/processActivityReadContext';
import { addOsasTreatmentSection } from './utils/addOsasTreatmentSection';

export function OsasConsultRead() {
    const { readSections } = useDefinedContext(ProcessActivityReadContext);

    return <ReadForm components={getComponents()} />;

    function getComponents(): ComponentsMap {
        const map = new Map();
        addOsasTreatmentSection(readSections, map);
        excludeFormComponent(map, 'cpapSetting');
        excludeFormComponent(map, 'cpapSettingText');
        excludeFormComponent(map, 'shouldHaveFollowUpConsult');
        excludeFormComponent(map, 'shouldHaveFollowingExamination');
        excludeFormComponent(map, 'taskFollowingExaminationOrConsultWeeks');

        return map;
    }
}
